import { fonts } from '~/src/helpers/font';
import { EElementType, ILandingElement } from '~/src/services/projects';

export const TariffCardsRA: ILandingElement = {
    title: 'TariffCardsRA',
    type: EElementType.Block,
    label: 'Карточки тарифов РА',
    properties: {
        blockName: '',
        customStyles: '',
        sortOrder: '',
        showDiscount: false,
        showBundles: true,
        bundlesAliases: '',
        showInternet: false,
        internetAliases: '',
        aliasWildcard: '',
        marginTop: '',
        marginBottom: '',
    },
    children: [
        {
            title: 'Title',
            type: EElementType.RTE,
            label: 'Заголовок',
            properties: {
                customize: {
                    font: fonts.H2,
                    color: '#1A1A1A',
                    textAlign: 'left',
                    tag: '',
                },
                htmlContent: 'Подключите тариф за 1₽',
                customStyles: '',
            },
        },
        {
            title: 'TopPrice',
            type: EElementType.Text,
            label: 'Цена верхний блок',
            properties: {
                customize: {
                    font: fonts.H1,
                    color: '#1A1A1A',
                    textAlign: 'left',
                },
                content: '',
                customStyles: '',
            },
        },
        {
            title: 'TopText',
            type: EElementType.Text,
            label: 'Текст верхний блок',
            properties: {
                customize: {
                    font: fonts.XS,
                    color: 'rgba(0,0,0,0.5)',
                    textAlign: 'left',
                },
                content: 'Первый месяц за каждую услугу в тарифе',
                customStyles: '',
            },
        },
        {
            title: 'BottomPrice',
            type: EElementType.Text,
            label: 'Цена нижний блок',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#1A1A1A',
                    textAlign: 'left',
                },
                content: '',
                customStyles: '',
            },
        },
        {
            title: 'BottomText',
            type: EElementType.Text,
            label: 'Текст нижний блок',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#1A1A1A',
                    textAlign: 'left',
                },
                content: 'со второго месяца',
                customStyles: '',
            },
        },
        {
            title: 'Button',
            type: EElementType.Button,
            label: 'Кнопка',
            properties: {
                customStyles: 'color: blue;',
                isTargetBlank: false,
            },
            children: [
                {
                    title: 'Text',
                    type: EElementType.Text,
                    label: 'Текст',
                    properties: {
                        customize: {
                            font: fonts.S,
                            color: '#FFF',
                            href: '',
                        },
                        content: 'Подключить',
                        customStyles: 'border: 1px solid red;',
                    },
                },
            ],
        },
    ],
};
